import { render, staticRenderFns } from "./MemberSimple.vue?vue&type=template&id=04128ba1&scoped=true&"
import script from "./MemberSimple.vue?vue&type=script&lang=js&"
export * from "./MemberSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04128ba1",
  null
  
)

export default component.exports